import type { VisibleCardViewV1, VisibleResourcePoolV1 } from "@fate-kingdom/engine";

export const RESOURCE_KEYS = ["food", "production", "trade", "science", "culture"] as const;
export type AlphaResourceKey = (typeof RESOURCE_KEYS)[number];

export function formatAlphaResources(pool: VisibleResourcePoolV1 | null | undefined): string {
  if (pool === null || pool === undefined) return "No cost";
  const entries = RESOURCE_KEYS.filter((key) => pool[key] > 0).map(
    (key) => `${key} ${String(pool[key])}`,
  );
  return entries.length === 0 ? "No cost" : entries.join(" · ");
}

export function alphaCardUseSummary(card: VisibleCardViewV1): string {
  if (card.type === "land") {
    return "Use your one Land Action during the action window. Found an empty lane or develop a matching Land.";
  }
  if (card.type === "commander") {
    return "Use your Deployment Action during the action window. A Commander leads one lane and enables normal formation attacks.";
  }
  if (card.type === "army") {
    return "Use your Deployment Action to station this Army on any active friendly Land, with or without a Commander.";
  }
  if (card.type === "event") {
    return "Play during your own action window while no mandatory choice is unresolved.";
  }
  return "This card type is not yet part of the public-beta playable content.";
}
